module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0904-fd4b2f676ebfbdc1c193c72480a810a2.jpg";